import React from 'react'
import ImageMasterViewTemplate from '../../templates/ImageMaster/ImageMasterView.template'

const ImageMasterViewPage = () => {
  return (
    <ImageMasterViewTemplate />
  )
}

export default ImageMasterViewPage